import { useEffect, useState } from "react";

export function useIsMobile() {
  const getIsMobile = () =>
    /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );

  const [isMobile, setIsMobile] = useState(getIsMobile);

  useEffect(() => {
    const check = () => setIsMobile(getIsMobile());
    // Listen to user agent changes if any (rare, mainly for dev tools emulation)
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  return isMobile;
}
